<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="75%">
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          color="#FF8B49"
          dark
          class=" text-capitalize f-14 lh-17 mt-2 mr-3"
        >
          <v-icon left v-if="title !== 'consolidate'"
            >mdi-filter-outline</v-icon
          >
          {{ title !== 'consolidate' ? 'Filter' : 'Consolidated Report' }}
        </v-btn>
      </template>
      <v-card class="rounded-12">
        <v-card-title
          class="primary white--text fs-16 lh-20 font-weight-bold py-4 px-6"
        >
          <img
            src="@/assets/images/icon/filter.png"
            width="20px"
            class="mr-3"
          />
          <span class="pa-0" v-if="title == 'topline'">
            Topline Report Filter
          </span>
          <span
            class="pa-0"
            v-else-if="
              title === 'budgeting' ||
                title === 'approval' ||
                title === 'report'
            "
          >
            {{ title === 'budgeting' ? 'Budget' : 'Spending' }}
            {{ title == 'approval' ? 'Approval' : 'Report' }}
            Filter
          </span>
          <span v-else class="text-capitalize">
            {{
              title === 'consolidate'
                ? 'Consolidated Report Filter'
                : title + ' Filter'
            }}
          </span>
          <v-spacer></v-spacer>
          <v-icon
            @click="dialog = false"
            color="white"
            class="fs-18"
            style="font-size: 20px !important; margin-right: -4px !important"
          >
            close
          </v-icon>
        </v-card-title>
        <v-perfect-scroll
          class="drawer-menu--scroll-dialog"
          :settings="scrollSettingsFilter"
        >
          <v-card-text class="pb-0 px-3 py-0 border-b-1">
            <v-container class="my-5" v-if="title === 'consolidate'">
              <h4 class="primary--text lh-17 mb-3">
                Select range year of report
              </h4>
              <v-row class="px-3">
                <v-flex xs6 class="pr-3">
                  <label class="textblack--text">Start Year</label>
                  <date-picker
                    v-model="year1"
                    type="year"
                    placeholder="Start Year"
                    format="YYYY"
                    class="fs-12"
                  >
                  </date-picker>
                </v-flex>
                <v-flex xs6 class="pl-3">
                  <label class="textblack--text">End Year</label>
                  <date-picker
                    v-model="year2"
                    type="year"
                    placeholder="End Year"
                    format="YYYY"
                    class="fs-12"
                  >
                  </date-picker>
                  <p class="fs-10 pt-1 lh-10 red--text mb-0">
                    {{ errorMessage }}
                  </p>
                </v-flex>
              </v-row>
            </v-container>
            <v-container class="py-0 form-filter" v-if="itemList.length > 0">
              <v-flex
                xs12
                class="pa-0"
                v-for="(division, indexDiv) in itemList"
                :key="'div-' + indexDiv"
              >
                <!-- <v-perfect-scroll
                  class="drawer-menu--scroll-vertical"
                  :settings="scrollSettingsFilter"
                > -->
                <v-row class="border-b-1 py-3">
                  <v-col
                    class="pt-4"
                    v-for="(itemGroup, indexGroup) in division.listGroup"
                    :key="'itemgroup-' + indexGroup"
                    :class="indexGroup !== 0 ? 'border-l-1' : ''"
                  >
                    <h4 class="primary--text lh-17 mb-3">
                      {{ itemGroup.name }}
                    </h4>
                    <v-perfect-scroll
                      class="drawer-menu--scroll-filter"
                      :settings="scrollSettingsFilter"
                    >
                      <div style="margin-left: -5px;">
                        <v-checkbox
                          v-for="(subgroup, indexList) in itemGroup.listGroup"
                          :key="'subgroup' + indexList"
                          v-model="subgroup.isSelected"
                          :label="subgroup.name"
                          @change="
                            getDetail(division, indexDiv, indexGroup, itemGroup)
                          "
                          color="menuActive"
                        >
                        </v-checkbox>
                      </div>
                    </v-perfect-scroll>
                  </v-col>
                </v-row>
                <!-- </v-perfect-scroll> -->
              </v-flex>
            </v-container>
            <v-container v-else-if="itemList.length === 0 && !isLoggedInAsBO">
              <v-flex
                xs12
                class="text-center textlightgrey--text pt-10"
                style="height: 130px"
              >
                No data displayed
              </v-flex>
            </v-container>
          </v-card-text>
        </v-perfect-scroll>
        <v-card-actions class="py-3 px-6">
          <v-btn
            color="primary"
            dark
            class="rounded-6 text-capitalize px-4"
            @click="getDivision"
          >
            Reset Filter
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="rounded-6 text-capitalize px-4"
            dark
            @click="parseData('report')"
          >
            View Data
          </v-btn>
          <!-- v-if="title === 'report' || title === 'topline'" -->
          <v-btn
            v-if="isDownload"
            color="menuActive"
            class="rounded-6 text-capitalize"
            dark
            @click="parseData('download')"
          >
            Download
          </v-btn>
        </v-card-actions>
        <v-fade-transition>
          <v-overlay v-if="progressDialogLoading" absolute>
            <div class="preloader-content">
              <img
                src="@/assets/images/loading.gif"
                style="width: 170%"
                alt="preloader"
              />
            </div>
          </v-overlay>
        </v-fade-transition>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import LoginAsMixin from '@/mixins/LoginAsMixin';
import moment from 'moment';

export default {
  props: {
    title: {
      type: String
    },
    isDownload: {
      type: Boolean,
      default: true
    }
  },
  mixins: [LoginAsMixin],
  data() {
    return {
      progressDialogLoading: false,
      dialog: false,
      objSelected: [],
      scrollSettingsFilter: {
        maxScrollbarLength: 283
      },
      itemList: [],
      year1: new Date(),
      year2: new Date()
    };
  },
  computed: {
    errorMessage() {
      let message = '';
      message =
        this.year2 >= this.year1
          ? ''
          : 'End date cannot smaller than start date';
      return message;
    }
  },
  mounted() {
    this.getDivision();
  },
  watch: {
    title() {
      this.getDivision();
    }
  },
  methods: {
    async getDivision() {
      const param = {
        profile_id: localStorage.getItem('profile_id')
      };
      return await this.$store
        .dispatch('advanceFilter/getDiv', param)
        .then(data => {
          if (data.code === 200) {
            if (this.isLoggedInAsFinance) {
              this.itemList = data.data.result.map(div => {
                return {
                  ...div,
                  listGroup: [
                    {
                      id: div.id,
                      name: div.type,
                      listGroup: [
                        {
                          id: div.id,
                          name: div.name,
                          isSelected: false,
                          type: div.type
                        }
                      ]
                    }
                  ]
                };
              });
            } else {
              this.itemList = [
                {
                  name: data.data.name,
                  listGroup: [
                    {
                      name: data.data.name,
                      listGroup: data.data.result.map(result => {
                        return {
                          ...result,
                          isSelected: false
                        };
                      })
                    }
                  ]
                }
              ];
            }
          } else {
            Swal.fire('Failed!', data.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.data.message.text_en, 'error');
        });
    },
    getDetail(itemParent, indexDiv, indexGroup, listGroup) {
      // ambil data yang diceklis
      let selected = listGroup.listGroup
        .filter(selectedFiltered => {
          return (
            selectedFiltered.isSelected === true &&
            selectedFiltered.type !== 'Budget Owner'
          );
        })
        .map(isSelected => {
          return isSelected.id;
        });
      let params = {
        division_id: itemParent.id,
        house_id:
          listGroup.listGroup[0].type.toLowerCase() === 'house'
            ? selected
            : listGroup.house_id || '',
        group_id:
          listGroup.listGroup[0].type.toLowerCase() === 'division' ||
          listGroup.listGroup[0].type.toLowerCase() === 'house'
            ? ''
            : selected
      };
      if (
        (selected.length > 0 && listGroup.name.toLowerCase() !== 'division') ||
        listGroup.name.toLowerCase() === 'division'
      ) {
        this.progressDialogLoading = true;
        this.$store
          .dispatch('advanceFilter/getDetail', params)
          .then(data => {
            this.progressDialogLoading = false;
            if (data.code === 200 && Object.keys(data.data).length > 0) {
              //cari index card (divisi)
              let indexCard = indexDiv;
              if (indexGroup >= 0) {
                // hapus group dibawahnya
                let listgroup = this.itemList[indexCard].listGroup.slice(
                  0,
                  indexGroup + 1
                );
                this.itemList[indexCard].listGroup = listgroup;
              }
              // push group baru
              itemParent.listGroup.push({
                name: data.data.name,
                house_id: data.data.house_id || '',
                listGroup: data.data.result.map(result => {
                  return {
                    ...result,
                    isSelected: false
                  };
                })
              });
            } else {
              if (data) {
                Swal.fire(
                  'Failed!',
                  data.response.data.data.message.text_en,
                  'error'
                );
              } else {
                Swal.fire('Failed!', 'Please try again', 'error');
              }
            }
          })
          .catch(err => {
            console.log(err);
            this.progressDialogLoading = false;
            Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          });
      }
    },
    parseData(typeAction) {
      // ambil data yang selected nya true
      let params = this.itemList.map(listCard => {
        let tempListGroup = listCard.listGroup.map(listGroup => {
          return listGroup.listGroup.filter(list => {
            return list.isSelected === true;
          });
        });
        return tempListGroup.filter(tempList => {
          return tempList.length > 0;
        });
      });
      // filter yang arraynya adaan
      let paramFilter = params.filter(param => {
        return param.length > 0;
      });
      // formating param
      let filter = paramFilter.map(item => {
        return {
          divisionIds: item
            .map(subitem => {
              return subitem.filter(sub => {
                return sub.type === 'Division';
              });
            })
            .filter(divList => {
              return divList.length > 0;
            }),
          houseIds: item
            .map(subitem => {
              return subitem.filter(sub => {
                return sub.type === 'House';
              });
            })
            .filter(houseList => {
              return houseList.length > 0;
            }),
          groupIds: item
            .map(subitem => {
              return subitem.filter(sub => {
                return sub.type === 'Group';
              });
            })
            .filter(groupList => {
              return groupList.length > 0;
            }),
          budgetOwnerIds: item
            .map(subitem => {
              return subitem.filter(sub => {
                return sub.type === 'Budget Owner';
              });
            })
            .filter(groupList => {
              return groupList.length > 0;
            })
        };
      });
      let filtered = filter.map(item => {
        return {
          divisionIds:
            item.divisionIds.length > 0
              ? item.divisionIds[0].map(itemdiv => {
                  return itemdiv.id;
                })
              : [],
          houseIds:
            item.houseIds.length > 0
              ? item.houseIds[0].map(itemhouse => {
                  return itemhouse.id;
                })
              : [],
          groupIds:
            item.groupIds.length > 0
              ? item.groupIds[item.groupIds.length - 1].map(itemgroup => {
                  return itemgroup.id;
                })
              : [],
          budgetOwnerIds:
            item.budgetOwnerIds.length > 0
              ? item.budgetOwnerIds[0].map(itembo => {
                  return itembo.id;
                })
              : []
        };
      });
      if (this.title === 'consolidate') {
        this.filterConsolidate(filtered);
      } else {
        this.dialog = false;
        this.$emit('getFiltered', {
          param:
            filtered.length > 0
              ? filtered
              : [
                  {
                    divisionIds: [],
                    houseIds: [],
                    groupIds: [],
                    budgetOwnerIds: []
                  }
                ],
          info: paramFilter,
          type: typeAction
        });
      }
    },
    filterConsolidate(filter) {
      // ambil data yang selected nya true
      let tempPush = [];
      let params = this.itemList.map(listCard => {
        let tempListGroup = listCard.listGroup.map(listGroup => {
          return listGroup.listGroup.filter(list => {
            return list.isSelected === true;
          });
        });
        return tempListGroup.filter(tempList => {
          return tempList.length > 0;
        });
      });
      // filter yang arraynya adaan
      let paramFilter = params.filter(param => {
        return param.length > 0;
      });
      //ambil level paling bawah yang dipilih
      let paramFilterLast = paramFilter.map(param => {
        return param[param.length - 1];
      });
      //ambil level paling pertama yang dipilih
      let paramFilterFirst = paramFilter.map(param => {
        return param[0];
      });
      //push array of object
      for (let a = 0; a < paramFilterLast.length; a++) {
        for (let b = 0; b < paramFilterLast[a].length; b++) {
          tempPush.push(paramFilterLast[a][b]);
        }
      }
      let tempData = tempPush;
      if (this.isLoggedInAsFinance) {
        for (let a = 0; a < paramFilterFirst.length; a++) {
          for (let b = 0; b < paramFilterFirst[a].length; b++) {
            tempData.push(paramFilterFirst[a][b]);
          }
        }
      }
      let filtered = tempData.filter(
        (val, index) => tempData.indexOf(val) === index
      );
      let div = filtered
        .filter(divFiltered => {
          return divFiltered.type.toLowerCase() === 'division';
        })
        .map(divMapped => {
          return divMapped.id;
        });
      let filters = '';
      if (filter.length > 0) {
        for (var i = 0; i < filter.length; i++) {
          filters +=
            `&filter[]={"divisionIds":[${filter[i].divisionIds}],` +
            `"houseIds":[${filter[i].houseIds}],` +
            `"groupIds":[${filter[i].groupIds}],` +
            `"budgetOwnerIds":[${filter[i].budgetOwnerIds}]}`;
        }
      }
      this.$router.push({
        name: 'consolidated-report',
        params: {
          yearFilter:
            moment(this.year1).format('YYYY') +
            '-' +
            moment(this.year2).format('YYYY')
        },
        query: {
          divisions: div.length > 0 ? div.filter(Boolean).join(',') : null,
          filter:
            filters.length > 0
              ? filters
              : `&filter[]={"divisionIds":[], "houseIds":[], "groupIds":[], "budgetOwnerIds":[]}`
        }
      });
    }
  }
};
</script>

<style scoped>
.v-input--selection-controls {
  margin-top: 0px !important;
  padding-top: 0px !important;
}
.drawer-menu--scroll-dialog {
  max-height: 450px;
  overflow: auto;
}
.drawer-menu--scroll-filter {
  max-height: 350px;
  overflow: auto;
}
.drawer-menu--scroll-vertical {
  max-width: 95%;
  overflow-x: auto;
}
v-dialog {
  overflow-y: hidden !important;
}
.preloader-content {
  position: absolute;
  top: 50%;
  width: 50px;
  left: 0;
  right: 0;
  margin: 0 auto;
  margin-top: -50px;
}
</style>
